export default function shareButton() {
  document.addEventListener('DOMContentLoaded', function() {
    const shareLinks = document.querySelectorAll('.share-list a')
    shareLinks.forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault()
        const url = window.location.href
        const socialNetwork = this.classList[0]

        switch (socialNetwork) {
          case 'facebook':
            window.open('https://www.facebook.com/sharer.php?u=' + encodeURIComponent(url), '_blank')
            break
          case 'instagram':
            window.open('https://www.instagram.com/', '_blank')
            break
          case 'linkedin':
            window.open('https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(url), '_blank')
            break
          case 'whatsapp':
            var title = encodeURIComponent(document.title)
            window.open('https://api.whatsapp.com/send?text=' + 'Acesse: ' + title + ' ' + encodeURIComponent(url), '_blank')
            break
          default:
            break
        }
      })
    })
  })
}
